import { apiSlice } from "./apiSlice";

const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    me: builder.mutation({
      query: () => ({
        url: "/user/me",
        method: "GET",
      }),
    }),
    updateProfile: builder.mutation({
      query: (user) => ({
        url: "/user/updateProfile",
        method: "PATCH",
        body: user,
      }),
      invalidatesTags: ["userProfile"],
    }),
    updateTradieHiringState: builder.mutation({
      query: () => ({
        url: "/user/tradie/toggleHiringStatus",
        method: "PATCH",
      }),
    }),
    upgradeToTradie: builder.mutation({
      query: () => ({
        url: "/user/freeTradie/upgrade",
        method: "PATCH",
      }),
    }),
  }),
});

export const {
  useMeMutation,
  useUpdateProfileMutation,
  useUpdateTradieHiringStateMutation,
  useUpgradeToTradieMutation,
} = userApi;
